import { inject } from '@angular/core';
import {
  patchState,
  signalStore,
  withMethods,
  withState,
} from '@ngrx/signals';
import { Entitlements, NewProductService, ProductStruct } from 'data/service/product-service';
import { NewProgressStore } from './progress.store';

type ProductState = {
  entitlements: Entitlements|null;
  selectedProduct: {
    id: string;
    title: string;
    subtitle: string;
    coverImage: string
    modules: ProductStruct
  } | null
  isLoadingEntitlements: boolean;
  isLoadingProduct: boolean;
};

const initialState: ProductState = {
  entitlements: null,
  selectedProduct: null,
  isLoadingEntitlements: false,
  isLoadingProduct: false,
};

export const NewProductStore = signalStore(
  { providedIn: 'root' },

  withState(initialState),
  withMethods((store,
    service = inject(NewProductService),
    // storeService = inject(StoreService), 
    // userStore = inject(UserStore), 
    progressStore = inject(NewProgressStore)
  ) => ({

    reset() {
      patchState(store, { entitlements: undefined, isLoadingEntitlements: false, });
    },

    async loadUserEntitlements() {
      console.log('Loading user entitlements');
      patchState(store, { isLoadingEntitlements: true });
      const entitlements = await service.getEntitlements();
      patchState(store, { entitlements, isLoadingEntitlements: false });
    },

    async loadProduct(productId: string) {
      if (store.isLoadingProduct()) {
        return;
      }

      //Check if already loaded
      if (store.selectedProduct()?.id === productId) {
        patchState(store, { isLoadingProduct: false });
        return;
      }

      //Check if product is in the list of entitlements (UI check only)
      const productEntitlement = store.entitlements()?.find(e => e.id);
      if (!productEntitlement) {
        patchState(store, { isLoadingProduct: false });
        return;
      }

      try {
        patchState(store, { isLoadingProduct: true });
        const productStruct = await service.getProductStruct(productId);
        progressStore.loadProgress(productId);

        patchState(store, {
          selectedProduct: {
            id: productEntitlement.id,
            title: productEntitlement.title,
            subtitle: productEntitlement.subtitle,
            coverImage: productEntitlement.coverImage,
            modules: productStruct
          },
          isLoadingProduct: false
        });
      } catch (error) {
        patchState(store, { isLoadingProduct: false });
      }
    },
  }))
);

